export enum AnamneseType {
    ACQ = 'ACQ',
    CCQ = 'CCQ',
    klachten = 'klachten',
    MRC = 'MRC',
}
